import { render, staticRenderFns } from "./FilterPriority.vue?vue&type=template&id=10583ac0"
import script from "./FilterPriority.vue?vue&type=script&lang=js"
export * from "./FilterPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports